module.exports = __webpack_public_path__ + "camera-white.png?70b31928161cd6fae6e7b1c420e444c5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/camera-white.png
// module id = 967
// module chunks = 0